// ── Dark / Light theme toggle ──────────────────────────────────────────
// Persists preference to localStorage and flips a data-theme attribute
// on <html>. Light theme colors are defined in sass/theme/_light.scss.

const STORAGE_KEY = "portfolio-theme";

function applyTheme(theme) {
  document.documentElement.setAttribute("data-theme", theme);
  const btn = document.getElementById("theme-toggle-btn");
  if (btn) {
    btn.setAttribute("aria-label", theme === "light" ? "Switch to dark mode" : "Switch to light mode");
    btn.classList.toggle("is-light", theme === "light");
  }
}

export default function initThemeToggle() {
  applyTheme("light");

  const btn = document.getElementById("theme-toggle-btn");
  if (!btn) return;

  btn.addEventListener("click", () => {
    const current = document.documentElement.getAttribute("data-theme") === "light" ? "light" : "dark";
    const next = current === "light" ? "dark" : "light";
    applyTheme(next);
  });
}
